import {engineContext} from './context.js';

(function(global){'use strict';
const VERSION='0.2.0-alpha';

function n(x){return x==null?'UNKNOWN':x;}

function urgency(x){
  x=x||{};
  let u=0;
  if(x.scope==='OWNED') u+=40;
  if(x.readiness==='BLOCKED') u+=35;
  else if(x.readiness==='REVIEW') u+=15;
  if(x.compoundSignal==='COMPOUND_NEGATIVE') u+=30;
  else if(x.compoundSignal==='BUILDING_NEGATIVE') u+=15;
  else if(x.compoundSignal==='COMPOUND_MIXED') u+=18;
  if((x.invalidatedConclusions||[]).length) u+=25;
  if((x.openGaps||[]).length) u+=Math.min(20,(x.openGaps||[]).length*5);
  if(x.thesisDrift==='MATERIAL_DRIFT') u+=30;
  else if(x.thesisDrift==='REVIEW_DRIFT') u+=15;
  if(x.meaningfulChange===true) u+=15;
  return u;
}

function brief(x){
  x=x||{};
  const why=[];
  if((x.invalidatedConclusions||[]).length) why.push(`${x.invalidatedConclusions.length} dependent conclusion(s) require review`);
  if(x.compoundSignal==='COMPOUND_NEGATIVE') why.push('independent negative changes now reinforce each other');
  else if(x.compoundSignal==='BUILDING_NEGATIVE') why.push('negative changes are beginning to cluster');
  else if(x.compoundSignal==='COMPOUND_MIXED') why.push('material positive and negative evidence coexist');
  if(x.thesisDrift==='MATERIAL_DRIFT') why.push('material thesis drift detected');
  else if(x.thesisDrift==='REVIEW_DRIFT') why.push('thesis drift needs review');
  if((x.openGaps||[]).length) why.push(`${x.openGaps.length} evidence gap(s) remain open`);
  if(x.readiness==='BLOCKED') why.push('decision readiness is blocked');

  const changed=x.changedSummary||(
    x.meaningfulChange===true?'Research state changed materially.':'No material research-state change.'
  );

  return Object.freeze({
    symbol:x.symbol||null,
    scope:x.scope||'RESEARCH',
    urgency:urgency(x),
    whatChanged:changed,
    whyItMatters:why.length?why.slice(0,3).join('; '):'No material escalation detected.',
    transmission:x.transmission||'No verified company-specific transmission supplied.',
    nextAction:x.nextTask||'No new research task.',
    readiness:n(x.readiness),
    tradeSignal:false,
    capitalPermission:false,
    universalScore:null
  });
}

function digest(items,limit){
  const rows=(Array.isArray(items)?items:[]).map(brief);
  rows.sort((a,b)=>b.urgency-a.urgency || (a.symbol||'').localeCompare(b.symbol||''));
  return Object.freeze(rows.slice(0,Number.isFinite(limit)?Math.max(1,limit):5));
}

function selfTest(){
  const t=[],ok=(name,p)=>t.push({name,pass:!!p});
  const owned={symbol:'AAA',scope:'OWNED',readiness:'BLOCKED',compoundSignal:'COMPOUND_NEGATIVE',invalidatedConclusions:['c1'],openGaps:['g1'],thesisDrift:'MATERIAL_DRIFT',meaningfulChange:true,nextTask:'Verify demand'};
  const watch={symbol:'BBB',scope:'WATCHLIST',readiness:'REVIEW',compoundSignal:'NO_COMPOUND_SIGNAL',invalidatedConclusions:[],openGaps:[],meaningfulChange:false};
  const b=brief(owned);

  ok('owned blocked case gets high urgency',b.urgency>brief(watch).urgency);
  ok('what changed is present',b.whatChanged.length>0);
  ok('why it matters is present',b.whyItMatters.length>0);
  ok('next action preserved',b.nextAction==='Verify demand');
  ok('blocked readiness preserved',b.readiness==='BLOCKED');
  ok('compound negative appears in explanation',b.whyItMatters.includes('negative'));
  ok('invalidation appears in explanation',b.whyItMatters.includes('conclusion'));
  ok('open gaps contribute to urgency',urgency({...owned,openGaps:[]})<urgency(owned));
  ok('material thesis drift contributes to urgency',urgency({...owned,thesisDrift:'STABLE'})<urgency(owned));
  ok('digest ranks owned critical first',digest([watch,owned],5)[0].symbol==='AAA');
  ok('digest respects limit',digest([owned,watch],1).length===1);
  ok('safe transmission fallback exists',brief(watch).transmission.length>0);
  ok('no trade signal',b.tradeSignal===false);
  ok('no capital permission',b.capitalPermission===false);
  ok('no universal score',b.universalScore===null);

  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}

const API={VERSION,urgency,brief,digest,selfTest};
try{API.selfTestResult=selfTest()}catch(e){API.bootstrapError=String(e&&e.stack||e)}
global.ZooInvestDailyDecisionBriefV2=Object.freeze(API);
})(engineContext);